<template>
  <div class="ma-2 ml-3 site_content">

    <v-tabs  centered >
      <v-tab class="info-tab">
        <v-icon color="#005B96">
          mdi-account-edit
        </v-icon>
        <span class="tab_text_green"> 인적사항 </span>
      </v-tab>
      <v-tab>
        <v-icon color="#005B96">
          mdi-account-key
        </v-icon>
        <span class="tab_text_red">비밀번호 </span>
      </v-tab>

      <v-tab-item class="set-tab">
        <ChangeMyInfo />
      </v-tab-item>
      <v-tab-item class="set-tab">
        <ChangePW />
      </v-tab-item>
    </v-tabs>

  </div>
</template>

<script>
import ChangePW from "./child/ChangePW.vue";
import ChangeMyInfo from "./child/ChangeMyInfo.vue";

export default {
  name: 'MyInfo',
  components: {
    ChangePW,
    ChangeMyInfo,
  },
  data () {
    return {
      tabs: null,
    }
  },
  created () {
    // console.log("info",this.$getters)
  },
}
</script>
<style lang="scss" scoped >
@import "../../style/base.scss";
.set-tab{
  background-color: #F3F3F3;
  display: flex;
  justify-content: center;
}
.tab_text_green{
  color:$main-color;
  font-size:12pt !important;
  font-weight: bold !important;
  margin-left:10px;
  // background-color: #3a4f3f !important;
}
.tab_text_red{
  color:$main-color;
  font-size:12pt !important;
  font-weight: bold !important;
  margin-left:10px;
  // background-color: #3a4f3f !important;
}
</style>
